// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_dd4049', '__Inter_Fallback_dd4049'","fontWeight":400,"fontStyle":"normal"},"className":"__className_dd4049","variable":"__variable_dd4049"};